export default __webpack_public_path__ + "static/media/make-cabinet-get-started-placeholder1@2x.dc0f8c81.png";